<template>
  <div class="crm-client-container">
    <!-- 面包屑导航 -->
    <Breadcrumb :levelList="levelList" />
    <div class="clearfix">
      <el-button type="primary" size="small" class="crm-add-tag" @click="handleAddTag()">添加标签</el-button>
    </div>
    <el-scrollbar class="crm-scrollbar">
    <!-- 表格组件： -->
    <div class="crm-table-container">
      <el-table
        v-loading="Loading"
        :data="tableList"
        style="width: 100%;"
        :header-cell-style="rowClass"
        :cell-style="cellStyle"
      >
        <el-table-column label="标签名称" align="center">
          <template slot-scope="scope">
            <span
              class="crm-tag"
              :style="{ 'background': scope.row.color ? scope.row.color : defaultColor }"
            >{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="color" label="标签颜色" align="center" v-if="show" />
        <el-table-column prop="createDate" label="添加时间" align="center" />
        <el-table-column prop="useCount" label="使用次数" align="center" />
        <el-table-column label="操作" align="center" width="80">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" content="编辑" placement="bottom">
              <i class="iconfont icontable-bianji" @click="handleAddTag(scope.row)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="删除" placement="bottom">
              <i
                class="iconfont icontable-delete"
                @click="handleDelTag(scope.row)"
                v-if="scope.row.useCount === 0"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页数据 -->
    <el-row style="float:right;margin-right: 10px">
      <el-pagination
        class="pageStyle"
        background
        layout="total, prev, pager, next, jumper"
        :page-size.sync="listQuery.size"
        :current-page.sync="listQuery.current"
        :total="total"
        @current-change="handlePagination"
      ></el-pagination>
    </el-row>
    </el-scrollbar>
    <!-- 添加标签组件 -->
    <addTagsComponent ref="addTag" @handlePagination="handlePagination" />
  </div>
</template>
<script>
import Breadcrumb from '@/views/components/crm/Breadcrumb'
import addTagsComponent from './components/addTag'
import { getPageLabelList, delLabel } from '@/api/crm/clientTag'
import { Message } from 'element-ui'

export default {
  components: { Breadcrumb, addTagsComponent },
  data() {
    return {
      total: 10,
      listQuery: {
        current: 1,
        size: 10
      },
      Loading: false,
      tableList: [],
      totalTableList: [],
      levelList: [{ path: '/client_tag', title: '客户标签' }],
      defaultColor: '#409EFF',
      show: false,
      mould: 3004
    }
  },
  created() {
    this.getList()
    this.getTotalTableList()
  },
  methods: {
    rowClass() {
      return 'background:#F5F5F5;border-right: 1px solid #fff;text-align:center;'
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label === '操作') {
        return 'text-align:center;padding-left:10px;'
      }
    },
    getTotalTableList() {
      this.totalTableList = this.tableList
    },
    getList() {
      const option = {
        current: this.listQuery.current,
        size: this.listQuery.size
      }
      getPageLabelList(option).then(res => {
        const data = res.data
        this.tableList = data.records
        this.total = data.total
      })
    },
    handlePagination() {
      this.getList()
    },
    handleAddTag(row) {
      if (row) {
        this.$refs.addTag.tagsForm = { ...row }
        this.$refs.addTag.action = 'edit'
      } else {
        this.$refs.addTag.action = 'add'
      }
      this.$refs.addTag.isShowRoleDialog = true
    },
    handleDelTag(row) {
      this.$confirm('是否删除当前标签，删除的标签信息将无法恢复', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = { id: row.id, mould: this.mould }
        delLabel(data)
          .then(res => {
            if (res.code === '2000') {
              Message.success('删除成功!')
            } else {
              Message.warning(res.meaning)
            }
            this.handlePagination()
          })
          .catch(res => {
            console.log(res)
            Message.error('删除失败!')
          })
      })
    }
  }
}
</script>
<style scoped lang="scss">
.crm-client-container {
  height: 100%;
  position: relative;
}
.crm-scrollbar {
  height: calc(100% - 50px - 62px);
}
.crm-add-tag.el-button {
  float: right;
  margin-top: 20px;
  margin-bottom: 10px;
}
.crm-tag {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 5px;
  color: #fff;
}
</style>
